import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "checkmark-gradient_svg__svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "url(#checkmark-gradient_svg__a)",
      "fill-rule": "evenodd",
      d: "M14.667 8A6.667 6.667 0 1 0 1.334 8a6.667 6.667 0 0 0 13.333 0ZM12 6l-1-1-4 4-2-2-1 1 3 3 5-5Z",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("defs", null, [
      _createElementVNode("linearGradient", {
        id: "checkmark-gradient_svg__a",
        x1: "2.227",
        x2: "13.774",
        y1: "11.333",
        y2: "4.667",
        gradientUnits: "userSpaceOnUse"
      }, [
        _createElementVNode("stop", { "stop-color": "#FF8C21" }),
        _createElementVNode("stop", {
          offset: "1",
          "stop-color": "#F5576E"
        })
      ])
    ], -1)
  ]))]))
}
export default { render: render }